const INITIAL_STATE = {
    isMobile: false,
    searchText: "",
    filter: [],
    todosServicos: [],
}

export default (state = INITIAL_STATE, action) => {

    switch (action.type){
        case 'BUSCAR_SERVICO_SET_STATE':
            const {key, value} = action.payload;
            if(key && value){
                return {...state, [key]: value};
            }
        default:
            return state;
    }
}